import React from "react";
import NoReply from "../emails/NoReply";
import AlertMessages from "./AlertMessages";

const AddEmail = () => {
  return (
    <div className="AddEmail">
      {/*Add Direct Email*/}
      <div
        className="modal fade"
        id={"AddEmailModal"}
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Add User Direct Email"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Add Direct Email</div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-form">
                <div className="field-wrapper">
                  <label for="forgotUser">Email Name</label>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control field-direct"
                      aria-label="Enter new email name"
                      aria-describedby="basic-addon2"
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text field-direct-addon"
                        id="basic-addon2"
                      >
                        @service2.directaddress.net
                      </span>
                    </div>
                  </div>
                </div>
                <div className="field-wrapper w-set1">
                  <label for="forgotUser">
                    What is the purpose of this email?
                  </label>
                  <div className="email-purpose-wrapper">
                    <select className="form-control" name="EmailPurpose">
                      <option value={0}>General</option>
                      <option value={1}>Medical Records XML only</option>
                      <option value={2}>Medical Records</option>
                      <option value={3}>Administrative</option>
                    </select>
                  </div>
                </div>
                <div className="field-wrapper">
                  <NoReply />
                  <label className="v-top">Set as no-reply mailbox</label>
                  <aside className="sp-margin13 line-s1">
                    Check this box if this mailbox cannot reply to emails.
                  </aside>
                </div>
                <AlertMessages />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-success">
                Add
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                Cancelsss
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AddEmail.defaultProps = {};

export default AddEmail;
